import { styled } from '@mui/material/styles';

import IconButton from '../IconButton';
import Popover from '../Popover';

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'fixed',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '5',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',
}));

export const StyledPopover = styled(Popover)({
  '& .MuiPaper-root': {
    border: '0',
    borderRadius: '2rem',

    '& > div': {
      width: '60rem',
    },
  },
});

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.base07,

  padding: '4rem',
}));

export const TopContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

export const TopLeftContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1rem',
});

export const DescriptionContainer = styled('div')(({ theme }) => ({
  margin: '2.7rem 0 3rem',

  color: theme.colors.base02,

  width: '100%',

  whiteSpace: 'pre-wrap',

  fontFamily: theme.typography.h5.fontFamily,
  fontSize: '1.8rem',
}));

export const WarningDescriptionContainer = styled('div')(({ theme }) => ({
  margin: '2.7rem 0 3rem',

  color: '#FF4034',

  width: '100%',

  whiteSpace: 'pre-wrap',

  fontFamily: theme.typography.h4.fontFamily,
  fontSize: '1.8rem',
}));

export const WarningContainer = styled('div')(({ theme }) => ({
  display: 'flex',

  columnGap: '2rem',

  padding: '2.3rem 2.7rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base06,
  borderRadius: '1rem',
}));

export const IconContainer = styled('div')({
  width: '3.2rem',
  height: '3.2rem',

  '& > svg': {
    width: '3.2rem',
    height: '3.2rem',
  },
});

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  '&:hover': {
    '& > svg': {
      '& > path': {
        fill: theme.colors.base03,
      },
    },
  },
}));

export const WarningIconContainer = styled('div')({
  width: '5rem',
  height: '5rem',

  '& > svg': {
    width: '5rem',
    height: '5rem',
  },
});

export const SeedPhraseContainer = styled('div')({});

export const SeedPhraseTopContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  color: theme.colors.base01,

  padding: '0 1rem',
}));

export const EncrpyionKeyContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const ViewIconContainer = styled('div')({
  width: '2.8rem',
  height: '2.8rem',

  '& > svg': {
    width: '2.8rem',
    height: '2.8rem',
  },
});

type QrCodeWrapperProps = {
  'data-is-view': boolean;
};

export const QrCodeWrapper = styled('div')<QrCodeWrapperProps>((props) => ({
  marginTop: '1.6rem',

  filter: props['data-is-view'] ? 'blur(0)' : 'blur(0.8rem)',
}));

export const CheckInstructionButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1.2rem',

  color: theme.colors.base02,
  backgroundColor: 'transparent',

  padding: '0',

  border: 'none',

  margin: '4rem 0',

  textAlign: 'left',

  '&:hover': {
    opacity: '0.8',
  },
}));

export const CheckButtonContainer = styled('div')({
  width: '2.4rem',
  height: '2.4rem',
});

export const CheckButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  width: '2.4rem',
  height: '2.4rem',

  border: `0.1rem solid ${theme.colors.base03}`,
  borderRadius: '0.4rem',
}));

export const CheckButtonIconContainer = styled('div')({
  width: '2rem',
  height: '2rem',

  '& > svg': {
    width: '2rem',
    height: '2rem',
  },
});
